import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "../components/auth/ProtectedRoute";
import { PublicRoute } from "../components/auth/PublicRoute";
import { Loading } from "../components/ui/Loading";
import ErrorBoundaryTester from '../components/ErrorBoundaryTester';

const Login = lazy(() => import("../pages/auth/Login"));
const Register = lazy(() => import("../pages/auth/Register"));
const ForgotPassword = lazy(() => import("../pages/auth/ForgotPassword"));
const VerifyEmail = lazy(() => import("../pages/auth/VerifyEmail"));
const UpdatePassword = lazy(() => import("../pages/auth/UpdatePassword"));
const ResendVerification = lazy(() => import("../pages/auth/ResendVerification"));
const LandingPage = lazy(() => import("../pages/LandingPage"));
const NotFound = lazy(() => import("../pages/NotFound"));
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const RestaurantProfile = lazy(() => import("../pages/dashboard/RestaurantProfile"));
const RestaurantRegistration = lazy(() => import("../pages/dashboard/RestaurantRegistration"));
const WaitlistDashboard = lazy(() => import("../pages/dashboard/WaitlistDashboard"));
const MarketingCampaigns = lazy(() => import("../pages/dashboard/MarketingCampaigns"));
const CreateCampaign = lazy(() => import("../pages/dashboard/CreateCampaign"));
const TemplateEditor = lazy(() => import("../pages/dashboard/TemplateEditor"));
const Analytics = lazy(() => import("../pages/dashboard/Analytics"));
const Settings = lazy(() => import("../pages/dashboard/Settings"));
const AdminPanel = lazy(() => import("../pages/admin/AdminPanel"));
const PublicWaitlist = lazy(() => import("../pages/public/PublicWaitlist"));
const WaitlistStatus = lazy(() => import("../pages/public/WaitlistStatus"));
const QRCodeDashboard = lazy(() => import("../pages/dashboard/qr-codes"));
const PromotionalForm = lazy(() => import("../pages/public/promotions"));
const QRCodeCreator = lazy(() => import("../pages/dashboard/qr-codes/QRCodeCreator"));
const PricingPage = lazy(() => import('../pages/Pricing'));

export default function AppRoutes() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        
        {/* Public auth routes using PublicRoute to prevent auto-redirects */}
        <Route element={<PublicRoute />}>
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/register" element={<Register />} />
          <Route path="/auth/forgot-password" element={<ForgotPassword />} />
          <Route path="/auth/verify-email" element={<VerifyEmail />} />
          <Route path="/auth/update-password" element={<UpdatePassword />} />
          <Route path="/auth/resend-verification" element={<ResendVerification />} />
        </Route>
        
        {/* Public Waitlist Routes */}
        <Route path="/waitlist/:restaurantId" element={<PublicWaitlist />} />
        
        {/* Promotional Routes */}
        <Route path="/promotions/:restaurantId" element={<PromotionalForm />} />
        
        <Route path="/waitlist/:restaurantId/status/:entryId" element={<WaitlistStatus />} />
        
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/profile" element={<RestaurantProfile />} />
          <Route path="/dashboard/restaurant-registration" element={<RestaurantRegistration />} />
          <Route path="/dashboard/waitlist" element={<WaitlistDashboard />} />
          <Route path="/dashboard/marketing" element={<MarketingCampaigns />} />
          <Route path="/dashboard/marketing/create" element={<CreateCampaign />} />
          <Route path="/dashboard/marketing/templates" element={<TemplateEditor />} />
          <Route path="/dashboard/analytics" element={<Analytics />} />
          <Route path="/dashboard/settings" element={<Settings />} />
          <Route path="/dashboard/qr-codes" element={<QRCodeDashboard />} />
          <Route path="/dashboard/qr-codes/create" element={<QRCodeCreator />} />
        </Route>
        
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/error-boundary-test" element={<ErrorBoundaryTester />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
} 
